// extracted by mini-css-extract-plugin
module.exports = {"currentImage":"UpdateVariantImage_currentImage__YjHW0","noImage":"UpdateVariantImage_noImage__29nN0"};